import React from 'react';
import { ButtonMode, Modal, Box, Button } from 'edenred-ui';
import { useTranslation, Trans } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

import { TopupConfirmationModalProps } from '@epi-models/pages/Transfer';
import { FormFields } from '@epi-forms/helpers';

import {
  ModalContent,
  ModalTitle,
  ModalMessage,
  Bold
} from './TopupConfirmationModal.styles';

export function TopupConfirmationModal({
  showModal,
  handleTopupRequest,
  handleCloseModal,
  employeesCount,
  totalAmount,
  isTopupPending,
  showOnHoldText,
  isPendingBenefit,
  topupAmount
}: TopupConfirmationModalProps) {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const benefitType = watch(FormFields.Benefit);

  return (
    <Modal open={showModal} onClose={handleCloseModal}>
      <ModalContent id="topup-confirmation_modal">
        <ModalTitle id="topup-confirmation_modal-title">
          {t('containers.deposit_money.topup_tab.confirmation_modal.title')}
        </ModalTitle>
        <ModalMessage>
          {isPendingBenefit && (
            <Box id="topup-confirmation_modal-pending-benefit-message" mb={2}>
              <Trans
                defaults={t(
                  'containers.deposit_money.topup_tab.confirmation_modal.pending_benefit_content',
                  {
                    benefitType: t(
                      `containers.deposit_money.topup_tab.confirmation_modal.benefits.${benefitType}`
                    )
                  }
                )}
                components={{
                  bold: <Bold />
                }}
              />
            </Box>
          )}
          <div id="topup-confirmation_modal-message">
            <Trans
              defaults={t(
                'containers.deposit_money.topup_tab.confirmation_modal.content',
                {
                  benefitType: t(
                    `containers.deposit_money.topup_tab.confirmation_modal.benefits.${benefitType}`
                  ),
                  topupAmount,
                  employeesCount,
                  totalAmount
                }
              )}
              components={{
                bold: <Bold />
              }}
            />
          </div>
          {showOnHoldText && (
            <Box id="topup-confirmation_modal-onhold-message" mt={2}>
              <Trans
                i18nKey={
                  'containers.deposit_money.topup_tab.confirmation_modal.on_hold_content'
                }
                components={{
                  bold: <Bold />
                }}
              />
            </Box>
          )}
        </ModalMessage>
        <Box marginBottom="24px">
          <Button
            onClick={handleTopupRequest}
            isProcessing={isTopupPending}
            id="topup-confirmation_confirm"
          >
            {t(
              'containers.deposit_money.topup_tab.confirmation_modal.buttons.confirm'
            )}
          </Button>
        </Box>
        <Button
          mode={ButtonMode.Link}
          onClick={handleCloseModal}
          id="topup-confirmation_cancel"
        >
          {t(
            'containers.deposit_money.topup_tab.confirmation_modal.buttons.cancel'
          )}
        </Button>
      </ModalContent>
    </Modal>
  );
}
